import styled, { css } from "styled-components";
import { COLORS, SCROLLBAR_STYLES } from "../../../constants/Styles";

export const ScrollContainer = styled.div<{ height?: string }>`
  overflow-x: scroll;
  width: 100%;
  ${({ height }) => height && `height: ${height};`}
  ${SCROLLBAR_STYLES};
`;

export const ShadowContainer = styled.div`
  position: relative;
  max-width: 100%;
  overflow: hidden;
  border-radius: 4px;
`;

const EDGE_SHADOW = css`
  position: absolute;
  top: 0;
  width: 1.5rem;
  height: 100%;
  pointer-events: none;
`;

export const ShadowLeft = styled.div`
  ${EDGE_SHADOW};
  left: 0;
  background: -webkit-linear-gradient(
    -90deg,
    ${COLORS.background},
    transparent
  );
  background: linear-gradient(-270deg, ${COLORS.background}, transparent);
`;

export const ShadowRight = styled.div`
  ${EDGE_SHADOW};
  right: 0;
  background: -webkit-linear-gradient(90deg, ${COLORS.background}, transparent);
  background: linear-gradient(270deg, ${COLORS.background}, transparent);
`;
